import { Serializable } from '../../../core/models/serializable';

export class FutureAnnouncements implements Serializable<FutureAnnouncements> {
  fromObject(object: any): FutureAnnouncements {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public date: Date;
  public renewals: FutureAnnouncement[];
  public futureAnnouncements: FutureAnnouncement[];
}

class FutureAnnouncement implements Serializable<FutureAnnouncement> {
  fromObject(object: any): FutureAnnouncement {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public announcementId: number;
  public title: string;
  public customerId: number;
  public customerName: string;
  public isRenewal: boolean;
}
